import Debouncer from '../lib/Debouncer';

const handleHomepageVideoVisibility = (): void => {
	const video = document.querySelector(".carousel__videoWrap > video") as HTMLVideoElement;
	const coveringElement = document.querySelector(".section") as HTMLElement;

	if (!video || !coveringElement) {
		console.error("Video or covering element not found");
		return;
	}

	const checkVisibility = (): void => {
		const videoRect = video.getBoundingClientRect();
		const coverRect = coveringElement.getBoundingClientRect();

		// Check if the video is completely covered
		const isCompletelyCovered =
			coverRect.top <= videoRect.top &&
			coverRect.bottom >= videoRect.bottom &&
			coverRect.left <= videoRect.left &&
			coverRect.right >= videoRect.right;

		if (isCompletelyCovered) {
			video.pause();
		} else {
			video.play();
		}
	};

	// Check on scroll and resize
	const debouncedCheckVisibility = new Debouncer(checkVisibility);
	window.addEventListener("scroll", debouncedCheckVisibility.run);
	window.addEventListener("resize", debouncedCheckVisibility.run);

	// Initial check
	checkVisibility();
};

export default () => {
	// Check if body has the "__entry" class and execute the function if true
	if (document.body.classList.contains("__entry")) {
		handleHomepageVideoVisibility();
	}
};